window.Shipping = (() => {

  const SHIPPING_PRODUCT_ID = 8046829895789;

  const VARIANTS = {
  moto_local: 45004822741101,
  moto_nacional: 45004822773869,
  vehiculo_local: 45004822806637,
  vehiculo_nacional: 45004822839405,
  carga_local: 45004822872173,
  carga_nacional: 45004822904941
};

  // =========================
  // 📦 CartService
  // =========================
  async function getCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  // =========================
  // 📍 LocationService
  // =========================
  function getLocation() {
    const data = localStorage.getItem("customer_location");
    return data ? JSON.parse(data) : null;
  }

  function isLocalZone(location) {
    if (!location) return false;

    const { lat, lng } = location;

    return (
      lat >= 14.0 &&
      lat <= 14.2 &&
      lng >= -87.3 &&
      lng <= -87.1
    );
  }

  // =========================
// 🧠 ShippingTypeResolver
// =========================
function resolveShippingType(cart) {

  let highestPriority = "moto";

  cart.items.forEach(item => {

    if (item.product_id === SHIPPING_PRODUCT_ID) return;

    const type =
      item.properties?.shipping_type ||
      item.properties?.["shipping_type"] ||
      null;

    console.log("🔍 Item:", item.title, "→", type);

    if (type === "carga") {
      highestPriority = "carga";
    }

    else if (type === "vehiculo" && highestPriority !== "carga") {
      highestPriority = "vehiculo";
    }

  });

  console.log("🚚 Tipo final:", highestPriority);

  return highestPriority;
}

// =========================
// ⚙️ ShippingRules
// =========================
function getVariantKey(type, isLocal) {
  return `${type}_${isLocal ? "local" : "nacional"}`;
}

// =========================
// 🔄 ShippingUpdater (FIX PRO)
// =========================
async function updateShippingVariant(variantId) {

  // 🛑 evitar doble ejecución GLOBAL
  if (updateShippingVariant.isRunning) return;
  updateShippingVariant.isRunning = true;

  const cart = await getCart();
  if (!cart || !cart.items) {
  updateShippingVariant.isRunning = false;
  return;
}

  const shippingItem = cart.items.find(
    item => item.product_id === SHIPPING_PRODUCT_ID
  );

  // 🟢 CASO 1: NO EXISTE → CREARLO
  if (!shippingItem) {

    console.log("➕ Creando producto de envío...");

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    // 🔥 REFRESH
    await refreshCartDrawer();

    // 🔓 liberar bloqueo
    updateShippingVariant.isRunning = false;

    return;
  }

  // 🟢 CASO 2: YA ES CORRECTO
  if (shippingItem.variant_id === variantId) {
    console.log("✅ Envío ya correcto");

    // 🔓 liberar bloqueo
    updateShippingVariant.isRunning = false;
    return;
  }

  console.log("🔄 Cambiando variante de envío...");
  console.log("🧪 Intentando cambiar a variantId:", variantId);

  const line = cart.items.findIndex(
    item => item.product_id === SHIPPING_PRODUCT_ID
  ) + 1;

  // 🔥 ELIMINAR ACTUAL
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: line,
      quantity: 0
    })
  });

  // 🔥 AGREGAR NUEVA VARIANTE
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  });

  console.log("✅ Variante actualizada correctamente");

  // 🔥 REFRESH UNA SOLA VEZ
  await refreshCartDrawer();

  // 🔓 liberar bloqueo
  updateShippingVariant.isRunning = false;
}

async function refreshCartDrawer() {

  console.log("🔄 Refrescando drawer...");

  const itemsEl = document.querySelector('cart-items-component');

  if (!itemsEl) {
    console.warn("❌ cart-items-component no encontrado");
    return;
  }

  const sectionId = itemsEl.sectionId;
  console.log("📦 sectionId:", sectionId);

  const res = await fetch(`/?sections=${sectionId}`);
  const data = await res.json();
  const html = data[sectionId];

  if (!html) {
    console.warn("❌ No HTML. Keys:", Object.keys(data));
    return;
  }

  const parser = new DOMParser();
  const newDoc = parser.parseFromString(html, 'text/html');
  const newItems = newDoc.querySelector('cart-items-component');

  if (newItems) {
    itemsEl.innerHTML = newItems.innerHTML;

    console.log("✅ Drawer actualizado correctamente");

    // 🔥 RE-ACTIVAR UI DE UBICACIÓN DESPUÉS DEL RENDER
    setTimeout(() => {
      if (typeof updateSavedAddressUI === "function") {
        updateSavedAddressUI();
      }
    }, 300);

  } else {
    console.warn("❌ cart-items-component no encontrado en HTML nuevo");
  }
}

  // =========================
  // 🚀 MAIN
  // =========================
  async function applyShippingLogic() {

    console.log("🚚 Calculando envío...");

    const cart = await getCart();
    // 🔥 SI CARRITO ESTÁ VACÍO → BORRAR UBICACIÓN
if (cart.items.length === 0) {

  console.log("🧹 Carrito vacío → limpiando ubicación");

  localStorage.removeItem("customer_location");

  // 🔄 actualizar UI
  if (typeof updateSavedAddressUI === "function") {
    updateSavedAddressUI();
  }

  return;
}

    // 🛑 SI CARRITO SOLO TIENE ENVÍO → ELIMINARLO
const nonShippingItems = cart.items.filter(
  item => item.product_id !== SHIPPING_PRODUCT_ID
);

if (nonShippingItems.length === 0) {

  const shippingItem = cart.items.find(
    item => item.product_id === SHIPPING_PRODUCT_ID
  );

  if (shippingItem) {

    const line = cart.items.findIndex(
      item => item.product_id === SHIPPING_PRODUCT_ID
    ) + 1;

    console.log("🗑 Eliminando envío (carrito vacío)");

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: 0
      })
    });

    await refreshCartDrawer();;
  }

  return;
}
    const location = getLocation();

    if (!location) {
      console.log("⚠️ No hay ubicación");
      return;
    }

    const type = resolveShippingType(cart);
    const isLocal = isLocalZone(location);
    const key = getVariantKey(type, isLocal);
    const variantId = VARIANTS[key];

    console.log({ type, isLocal, key, variantId });

    if (!variantId) return;

    await updateShippingVariant(variantId);
  }

let lastShippingType = "moto";

document.addEventListener("click", (e) => {

  const button = e.target.closest('button[name="add"]');

  if (!button) return;

  const shippingType = button.dataset.shippingType;

  if (shippingType) {
    lastShippingType = shippingType;
    console.log("🧠 Capturado REAL shipping_type:", shippingType);
  }

}, true);

// =========================
// 🚀 INTERCEPT FETCH (SOLUCIÓN REAL)
// =========================
if (!window._originalFetch) {
  window._originalFetch = window.fetch;
}

window.fetch = async function (...args) {

  const [url, config = {}] = args;

  // 🔥 SOLO interceptar cuando se AGREGA producto
  if (typeof url === "string" && url.includes("/cart/add")) {

    try {

      let body = config?.body;
      const shippingType = lastShippingType || "moto";

      // 🟢 FormData
      if (body instanceof FormData) {
        body.set("properties[shipping_type]", shippingType);
      }

      // 🟢 JSON
      else if (typeof body === "string") {

        let data = {};

        try {
          data = JSON.parse(body);
        } catch (e) {
          data = {};
        }

        // ⚠️ NO sobrescribir si ya existe
        if (!data.properties?.shipping_type) {
          data.properties = {
            ...(data.properties || {}),
            shipping_type: shippingType
          };
        }

        config.body = JSON.stringify(data);
      }

      console.log("🚚 shipping_type aplicado (ADD):", shippingType);

    } catch (err) {
      console.error("Error interceptando shipping:", err);
    }
  }

  // 🔥 ejecutar fetch real SIEMPRE
  const response = await window._originalFetch.apply(this, args);

  return response;
};


return {
  applyShippingLogic
};

})();